import React, { Component, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Api from "../../Api";
import { useScrollTrigger } from '@material-ui/core';

export default ({InfIdConta, Dados, DadEmp}) => {
  const [Loading, setLoading] = useState(false)
  const [Quant, setQuant] = useState(0)
  const [UsuariosContServ, setUsuariosContServ] = useState([])
  const [Entrega, setEntrega] = useState(0)
  const [Porcucao, setPorcucao] = useState(0)
  const [Confimacao, setConfimacao] = useState(0)
  const [Chatlist, setChatlist] = useState([])
  const [RoboDesati, setRoboDesati] = useState(0)
  const [MsgAtiv, setMsgAtiv] = useState(0)
  const [TaxaEnt, setTaxaEnt] = useState(0)
  const [PedConf, setPedConf] = useState(0)
  const [BuscaAti, setBuscaAti] = useState(0)
  const [Apg, setApg] = useState(0)
  const [NomeCli, setNomeCli] = useState(0)

 useEffect(() => {
    Notificacao();     
   }, [])
  useEffect(() => {
    DadoDelivery();     
   }, [])

   useEffect(() => {
    NotiDelivery();     
   }, [UsuariosContServ])

   useEffect(() => {
    DadoChat();     
   }, [])

   useEffect(() => {
    NotiChat();     
   }, [Chatlist])

   const Notificacao = () => {
    //addEventListener('Load')

  }

   const DadoChat = () => {
    Api.PesquisarList(Dados, setChatlist )
  }
  const NotiChat = () => {
   
   
    setRoboDesati(Chatlist.length)

    
    
   
  }
   

   const DadoDelivery = () => {
    Api.PedidoDelivery(Dados, setLoading, setQuant, setUsuariosContServ)
  }
  const NotiDelivery = () => {
    var NotMsg = 0
    var NotEnt = 0
    var NotProd = 0
    var NotConfir = 0
    var NotTaxaEnt = 0
    var NotPediConf = 0
    var NotBuscar = 0
    var NotPag = 0
    var NotNome = 0
     for(let i  in UsuariosContServ){
      if(UsuariosContServ[i].ClienteEsc === true && UsuariosContServ[i].IdChat){
        NotMsg = NotMsg + 1;
      }
      if(UsuariosContServ[i].NomeCli === "" ){
        NotNome = NotNome + 1;
      }
      if(UsuariosContServ[i].FormaDepagamento === null  ){
        NotPag = NotPag + 1;
      } else {
        if(UsuariosContServ[i].Pix === true  ){
          if(UsuariosContServ[i].ExtratoPix === null ){
          NotPag = NotPag + 1;
          }
        } 
        if(UsuariosContServ[i].Dinheiro === true  ){
          if(UsuariosContServ[i].TrocoDinheiro === "" ){
          NotPag = NotPag + 1;
          }
        } 
      }

       if(UsuariosContServ[i].Buscar === false ){
        if(UsuariosContServ[i].End[0] === "" || UsuariosContServ[i].End.length === 0  ){
          NotEnt = NotEnt + 1;
        }
       }
       if(UsuariosContServ[i].ConcluidoProducao === true && UsuariosContServ[i].IniciandoEntrega === false ){
        NotProd = NotProd + 1;
      }
      if(UsuariosContServ[i].Buscar === false ){
      if(UsuariosContServ[i].ValorEntrega === 0  ){
        NotTaxaEnt = NotTaxaEnt + 1;
      }
      }
      if(UsuariosContServ[i].PedConstruido  === false  ){
        NotPediConf = NotPediConf + 1;
      }
      if(UsuariosContServ[i].ConfirmacaoPedido === true && UsuariosContServ[i].IniciandoProducao === false ){
        NotConfir = NotConfir + 1;
      }
      if(UsuariosContServ[i].Buscar === true ){
       
        NotBuscar = NotBuscar + 1;
        
        }
     }
     setMsgAtiv(NotMsg)
     setPedConf(NotPediConf)
     setEntrega(NotEnt)
     setPorcucao(NotProd)
     setConfimacao(NotConfir)
     setTaxaEnt(NotTaxaEnt)
     setBuscaAti(NotBuscar)
     setApg(NotPag)
     setNomeCli(NotNome)
  }

  return (
<div>
 {/* Navbar */}
  <nav className="main-header navbar navbar-expand navbar-white navbar-light">
    {/* Left navbar links */}
    <ul className="navbar-nav">
      <li className="nav-item">
        <a className="nav-link" data-widget="pushmenu" href="#"><i className="fas fa-bars" /></a>
      </li>
      <li className="nav-item d-none d-sm-inline-block">
        {InfIdConta &&
        <>
        {InfIdConta.Logo &&
        <>
        <img src={InfIdConta.Logo} alt="imagem" style={{width:40, height:40}} /> 
        </>
        }
        </>
        }
       
      </li>
      <li className="nav-item d-none d-sm-inline-block">
        {InfIdConta &&
        <>
       
        <a href="#" className="nav-link">{InfIdConta.NomeApp}</a>
        </>
        }
       
      </li>
    </ul>
   
    
     
  </nav>
  {/* /.navbar */}
</div>

        );
    }

